import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SalesReport from '../../pages/reports/SalesReport';
import PurchaseReport from '../../pages/reports/PurchaseReport';
import InventoryReport from '../../pages/reports/InventoryReport';
import BillingReports from './BillingReports';
import CreditCustomersReport from '../../pages/reports/CreditCustomersReport';
import CreditSuppliersReport from '../../pages/reports/CreditSuppliersReport';
import InvoiceProfitLossReport from '../../pages/reports/InvoiceProfitLossReport';
import ProductsReport from '../../pages/reports/ProductsReport';
import StockReport from '../../pages/reports/StockReport';
import StockMatrixReport from '../../pages/reports/StockMatrixReport';
import DayCloseReport from '../../pages/reports/DayCloseReport';
import StockTransferReport from '../../pages/reports/StockTransferReport';
import LocationSalesReport from '../../pages/reports/LocationSalesReport';
import TopSellingProductsReport from '../../pages/reports/TopSellingProductsReport';
import GSTReport from '../../pages/reports/GSTReport';
import GSTR2Report from '../../pages/reports/GSTR2Report';
import HSNReport from '../../pages/reports/HSNReport';
import CounterReport from '../../pages/reports/CounterReport';
import SalesmanReportPage from '../../pages/reports/SalesmanReportPage';
import CustomerLoyaltyReportPage from '../../pages/reports/CustomerLoyaltyReportPage';

const Reports = () => {
  return (
    <Routes>
      <Route path="sales" element={<SalesReport />} />
      <Route path="counter-reports" element={<CounterReport />} />
      <Route path="location-sales" element={<LocationSalesReport />} />
      <Route path="salesman" element={<SalesmanReportPage />} />
      <Route path="customer-loyalty" element={<CustomerLoyaltyReportPage />} />
      <Route path="top-selling-products" element={<TopSellingProductsReport />} />
      <Route path="purchases" element={<PurchaseReport />} />
      <Route path="inventory" element={<InventoryReport />} />
      <Route path="stock" element={<StockReport />} />
      <Route path="stock-matrix" element={<StockMatrixReport />} />
      <Route path="day-close" element={<DayCloseReport />} />
      <Route path="stock-transfer" element={<StockTransferReport />} />
      <Route path="billing" element={<BillingReports />} />
      <Route path="invoice-profit-loss" element={<InvoiceProfitLossReport />} />
      <Route path="credit-customers" element={<CreditCustomersReport />} />
      <Route path="credit-suppliers" element={<CreditSuppliersReport />} />
      <Route path="products" element={<ProductsReport />} />
      <Route path="gst" element={<GSTReport />} />
      <Route path="gstr2" element={<GSTR2Report />} />
      <Route path="hsn" element={<HSNReport />} />
      <Route path="*" element={<Navigate to="/reports/credit-customers" replace />} />
    </Routes>
  );
};

export default Reports; 
